'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, PropsWithChildren, useCallback, useContext, useMemo, useState } from 'react';
import { ComingSoonDrawer } from './ComingSoonDrawer';
type ComingSoonDrawerContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};
const ComingSoonDrawerContext = createContext<ComingSoonDrawerContextValue | null>(null);
export function ComingSoonDrawerProvider(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const open = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const close = t2;
  let t3;
  if ($[2] !== isOpen) {
    t3 = {
      isOpen,
      open,
      close
    };
    $[2] = isOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const value = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ComingSoonDrawer />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== value) {
    t5 = <ComingSoonDrawerContext.Provider value={value}>{children}{t4}</ComingSoonDrawerContext.Provider>;
    $[5] = children;
    $[6] = value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
export function useComingSoonDrawer() {
  const context = useContext(ComingSoonDrawerContext);
  if (!context) {
    throw new Error("useComingSoonDrawer must be used within a ComingSoonDrawerProvider");
  }
  return context;
}